<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.categoriePrestation') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <section class="container" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
                                        <b-button @click="handleOnAddClick" v-if="can">
                                            <i class="fa fa-plus edit-icon"></i>
                                            {{ $t('message.add') }}
                                        </b-button>

                                        <div class="d-inline-block ml-1 mr-5 width-270">
                                            <b-input-group
                                                    size="sm"
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        size="sm"
                                                        class="p-2 h-100"
                                                        :placeholder="$t('message.filter') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>

                                            <div
                                                    v-if="paginationObject.numOfPages > 1"
                                                    class="pagination-wrapper d-inline-block"
                                            >
                                                <div class="pagination">
                                                    <a
                                                            href="#"
                                                            :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('prev')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                    </a>
                                                    <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                        <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                        </template>
                                                        <template v-else>
                                                            <a
                                                                    href="#"
                                                                    :key="key"
                                                                    class="page-numbers"
                                                                    @click="_handlePaginationClick(pageNumber)"
                                                            >
                                                                {{ pageNumber }}
                                                            </a>
                                                        </template>
                                                    </template>
                                                    <a
                                                            href="#"
                                                            class="next page-numbers"
                                                            :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                            @click="_handlePaginationClick('next')"
                                                    >
                                                        <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row appointment-table-content">
                                        <div class="container-fluid">
                                            <template
                                                    v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                            >
                                                <div
                                                        v-for="(category, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                        :key="key"
                                                        class="row appointment-item hovered"
                                                        @click="onCategorieClick(category.slug)"
                                                >
                                                    <div class="col-lg-4">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomEtablissement') }}
                                                        </span>
                                                        <h4 class="appointment-date">{{ category.name }}</h4>
                                                    </div>
                                                    <!--<div class="col-lg-8">
                                                        <span class="appointment-label">
                                                            {{ $t('message.description') }}
                                                        </span>
                                                        <h4
                                                                class="appointment-hour"
                                                        >
                                                            {{ category.description }}
                                                        </h4>
                                                    </div>-->
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                </section>
                                <!--<vue-good-table
                                        id="operation"
                                        :columns="categorieColumns"
                                        :rows="categorieRows"
                                        :search-options="{
                                        enabled:true,
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="onCategorieClick"
                                />-->
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
	import { pagination, handlePaginationClick } from "../../helpers/paginations";

    export default {
        name: "List",
        computed: {
            ...mapGetters([
                "categoriePrestations",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole',
                'isComptable'
            ]),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || hasAssistante;
            },

            categorieColumns: function () {
                return [
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'nom',
                    }
                ];
            },

            categorieRows:function(){
                let cArray = [];
                _.forEach(this.categoriePrestations,function (categorie) {
                    cArray.push({
                        nom:categorie.nom,
                        slug:categorie.slug
                    });
                })
                return cArray;
            }
        },

        data(){
            return {
				filterCriteria: '',
				categories: [],
				paginationObject: {},
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },
        watch: {
			categoriePrestations: function (newValue, oldValue) {
				this.categories = newValue
					.map(category => ({
						slug: category.slug,
						name: category.nom,
					}));
			},

			categories: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
				this.handleFilter(newValue);
			}
        },
        methods:{
			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
					const newCategories = this.categories.filter(app => {
						let result = false;

						if (app.name) {
							result = result || app.name.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					this.paginationObject = pagination(newCategories);
				} else {
					this.paginationObject = pagination(this.categories);
				}
			},

            getCategoriePrestations() {
                let args = {

                };

                this.$store.dispatch('getCategoriePrestations', { args : args });
            },

			handleOnAddClick() {
				this.$router.push({ name: 'add-categorie-prestation' });
            },

            onCategorieClick(slug){
                this.$router.push({ name: 'categorie-prestation', params: { categorie: slug } });
            }
        },

        mounted() {
            this.getCategoriePrestations();
        }
    }
</script>

<style scoped>

</style>
